import React from 'react';
import { Text, View } from 'react-native';

import { formatTimeEvent, convertTimeLetter } from '@helpers';
import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import { getStatusText, renderStatusIcon } from '@components/search/ncFiles/helpers';
import Empty from '@components/common/Empty';

export default ({ C, item, showName, showIcon, showStatusText }) => {
  if (!item) {
    return null;
  }

  const statusText = getStatusText(item.ncFileStatus);

  return (
    <View style={{ marginTop: scale(showName ? 0 : 5), flexDirection: 'row', overflow: 'hidden', alignItems: 'center' }}>
      <Text numberOfLines={1}>
        {showIcon && <View style={{ marginRight: scale(5) }}>{renderStatusIcon(item.ncFileStatus)}</View>}
        {showStatusText && statusText && (
          <Text style={[font['Subhead 1'], { color: C('Label/Light/Tertiary'), marginRight: scale(5) }]}>
            {statusText}
            <Empty />
          </Text>
        )}
        {showName && (
          <>
            <Text>
              <Text style={[font['Button 1'], { color: C('Label/Light/Primary') }]}>{item.ncFileName} </Text>
            </Text>
            <Text style={[{ color: C('Label/Light/Tertiary') }, font['Subhead 1']]}>-</Text>
          </>
        )}
        <Text style={[{ color: C('Status/Light/Active') }, font['Subhead 1']]}>
          {formatTimeEvent(convertTimeLetter(item.runTimePerPcsSecond), false)}
          <Empty />
        </Text>
        <Text style={[{ color: C('Label/Light/Tertiary') }, font['Subhead 1']]}>
          –<Empty />
        </Text>
        <Text style={[{ color: C('Status/Light/Change') }, font['Subhead 1']]}>
          {formatTimeEvent(convertTimeLetter(item.changeTimePerPcsSecond), false)}
          <Empty />
        </Text>
        <Text style={[{ color: C('Label/Light/Tertiary') }, font['Subhead 1']]}>
          –<Empty />
        </Text>
        <Text style={[{ color: C('Status/Light/Setup') }, font['Subhead 1']]}>
          {formatTimeEvent(convertTimeLetter(item.setupTimeSecond), false)}
          <Empty />
        </Text>
      </Text>
    </View>
  );
};
